module.exports = __webpack_public_path__ + "img/74815e1.svg";